import React from 'react'
import * as classNames from 'classnames'
import { ChevronDown16, ChevronUp16 } from '@carbon/icons-react'
const SimpleTextAccordion = ({
  id,
  value,
  fontSize = 'md',
  type = 'default',
  bold = true,
  decoration = 'none', //success or danger
  open = false,
  data,
  setData
}) => {
  const accordionAction = ({ currentTarget }) => {
    const newData = data.map((sData) => {
      const { name, father } = sData
      if (name === currentTarget.id) {
        return {
          ...sData,
          open: !sData.open
        }
      } else if (father === currentTarget.id) {
        return {
          ...sData,
          show: !sData.show
        }
      } else return sData
    })
    setData(newData)
  }

  return (
    <div
      id={id}
      className={classNames('kpi-card', {
        [`type-${type}`]: true,
        'green-border': decoration === 'success',
        'red-border': decoration === 'danger'
      })}
      onClick={accordionAction}
    >
      <div className='ovs-group-span'>
        <span
          className={classNames('card-value', {
            [`font-size-${fontSize}`]: true,
            'bold-style': bold
          })}
        >
          {value}
        </span>
        {open ? (
          <span>
            <ChevronUp16 />
          </span>
        ) : (
          <span>
            <ChevronDown16 />
          </span>
        )}
      </div>
    </div>
  )
}

export default SimpleTextAccordion
